import type { Software } from "@/utils/software";
import { platformIcons } from "@/utils/ui";

interface Props {
  item: Software;
  onDownload: (item: Software) => void;
}

export default function DownloadPanel({ item, onDownload }: Props) {
  return (
    <div className="card-surface flex flex-col gap-4 p-5">
      <div className="flex items-center gap-2">
        <i className="ri-download-cloud-2-line text-lg text-primary-600" />
        <h3 className="font-heading text-base font-bold text-foreground-900">下载安装</h3>
      </div>

      <div className="flex flex-col gap-2">
        {item.platforms.map((platform) => (
          <button
            key={platform}
            type="button"
            onClick={() => onDownload(item)}
            className="flex items-center justify-between gap-3 rounded-md border border-background-300 px-4 py-3 text-sm font-medium text-foreground-800 transition-colors hover:border-primary-400 hover:bg-primary-50 cursor-pointer"
          >
            <span className="flex items-center gap-2">
              <i className={`${platformIcons[platform] ?? "ri-computer-line"} text-lg text-primary-600`} />
              {platform} 版
            </span>
            <span className="flex items-center gap-1 text-xs text-foreground-500">
              下载 <i className="ri-arrow-down-line" />
            </span>
          </button>
        ))}
      </div>

      <div className="flex flex-col items-center gap-2 rounded-lg bg-background-100 p-4">
        <div className="flex h-[150px] w-[150px] items-center justify-center overflow-hidden rounded-md border border-background-300 bg-background-50">
          <img
            src="https://api.qrserver.com/v1/create-qr-code/?size=150x150&data=https%3A%2F%2Fwww.huangjinruanjianapp.com%2F"
            alt="扫码打开下载页面二维码"
            title="扫码下载"
            className="h-[140px] w-[140px]"
          />
        </div>
        <p className="text-center text-xs text-foreground-500">
          手机扫码直达下载页
          <br />
          （演示二维码）
        </p>
      </div>

      <p className="flex items-start gap-2 rounded-md border border-accent-200 bg-accent-50 p-3 text-xs leading-relaxed text-accent-900">
        <i className="ri-error-warning-line mt-0.5 text-base" />
        本站为演示站点，下载按钮指向示范链接，不提供真实软件下载，请在软件官方网站获取正式版本。
      </p>
    </div>
  );
}